import * as gochiMenuActions from '../actions/GochiMenus';

const initialState = {
  menus: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  taxTypes: [
    {
      id: 'EXTERNAL',
      name: '外税'
    },
    {
      id: 'INTERNAL',
      name: '内税'
    },
    {
      id: 'DONATION',
      name: '寄付'
    }
  ],
  detail: {
    shopId: 1,
    menuId: 1,
    shopName: '店舗A',
    menuName: 'オムライス',
    description: 'ふわっふわなオムライスです。',
    price: 800,
    taxType: 'INTERNAL',
    taxTypeStr: '内税',
    reducedTax: 'UNREDUCED',
    image:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/menu/omu.png',
    createdAt: '2019-01-01 12:00:00',
    updatedAt: '2019-02-01 12:00:00',
    tags: [
      {
        tagId: 1,
        tagName: 'タグ1',
        viewOrder: 1
      },
      {
        tagId: 2,
        tagName: 'タグ2',
        viewOrder: 2
      },
      {
        tagId: 3,
        tagName: 'タグ3',
        viewOrder: 3
      },
      {
        tagId: 4,
        tagName: 'タグ4',
        viewOrder: 4
      },
      {
        tagId: 5,
        tagName: 'タグ5',
        viewOrder: 5
      },
      {
        tagId: 6,
        tagName: 'タグ6',
        viewOrder: 6
      }
    ]
  },
  orderMenus: {
    menus: []
  },
  showHide: [
    {
      id: '',
      name: '選択なし'
    },
    {
      id: '0',
      name: '非表示'
    },
    {
      id: '1',
      name: '表示'
    }
  ],
  menuChildType: [
    {
      id: '1',
      name: '通常'
    },
    {
      id: '2',
      name: 'こども食堂用(単独)'
    },
    {
      id: '3',
      name: 'こども食堂用(仮想店舗)グループ'
    },
    {
      id: '4',
      name: 'グループ共通メニュー'
    },
    {
      id: '5',
      name: '地域通貨チケット'
    }
  ],
  error: false,
  status: 200,
  error_message: ''
};

const gochiMenus = (state = initialState, action) => {
  switch (action.type) {
    case gochiMenuActions.GET_GOCHI_MENUS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochiMenuActions.GET_GOCHI_MENUS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error,
        menus: [],
        totalCount: 0
      });
    case gochiMenuActions.GET_ORDER_GOCHI_MENUS_SUCCESS:
      return Object.assign({}, state, { orderMenus: action.payload });
    case gochiMenuActions.GET_ORDER_GOCHI_MENUS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiMenuActions.CLEAR_ORDER_GOCHI_MENUS:
      return Object.assign({}, state, {
        orderMenus: { menus: [] }
      });
    case gochiMenuActions.GET_GOCHI_MENU_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case gochiMenuActions.GET_GOCHI_MENU_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiMenuActions.CREATE_SECRET_GOCHI_MENU_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case gochiMenuActions.CREATE_SECRET_GOCHI_MENU_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiMenuActions.GET_MENU_ONE_TO_N_SUCCESS:
      return Object.assign({}, state, { list: action.payload });
    case gochiMenuActions.GET_MENU_ONE_TO_N_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiMenuActions.GET_MENU_SETTING_SUCCESS:
      return Object.assign({}, state, { setting: action.payload });
    case gochiMenuActions.GET_MENU_SETTING_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    // case gochiMenuActions.ADD_MENU_SETTING_SUCCESS:
    //   return Object.assign({}, state, { setting: action.payload });
    // case gochiMenuActions.ADD_MENU_SETTING_FAILURE:
    //   return Object.assign({}, state, {
    //     status: action.payload,
    //     error: action.error
    //   });
    case gochiMenuActions.UPDATE_MENU_SETTING_SUCCESS:
      return Object.assign({}, state, { setting: action.payload });
    case gochiMenuActions.UPDATE_MENU_SETTING_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiMenuActions.GET_LIST_SETTING_MENU_FREE_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochiMenuActions.GET_LIST_SETTING_MENU_FREE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default gochiMenus;
